import { OrgAdminInfo, ProfileInfo } from '@fullstory/client-api';
import { combineReducers } from 'redux';
import { RequestActionType } from '@fullstory/redux-util';
import { ProfileSettingsRequestActions } from './actions';
import { ProfileSettingsTypes } from './types';

export const orgAdminInfo = (
  state: OrgAdminInfo | null = null,
  action: RequestActionType<typeof ProfileSettingsRequestActions>,
) => {
  switch (action.type) {
    case ProfileSettingsTypes.GetOrgAdminInfoSuccess:
      return action.data;
    case ProfileSettingsTypes.UpdateOrgAdminInfoSuccess:
      return action.request.body ?? state;
  }
  return state;
};

export const profileInfo = (
  state: ProfileInfo | null = null,
  action: RequestActionType<typeof ProfileSettingsRequestActions>,
) => {
  switch (action.type) {
    case ProfileSettingsTypes.GetProfileInfoSuccess:
      return action.data.ProfileInfo;
    case ProfileSettingsTypes.UpdateProfileInfoSuccess: {
      const { body } = action.request;

      if (body == null) throw new Error('Invariant violation: Request body must exist.');

      return {
        FirstName: body.FirstName ? body.FirstName : state?.FirstName ? state.FirstName : '',
        LastName: body.LastName ? body.LastName : state?.LastName ? state.LastName : '',
        Personas: body.Personas?.length
          ? body.Personas
          : state?.Personas?.length
          ? state.Personas
          : [],
        Reason: body.Reason ? body.Reason : state?.Reason ? state.Reason : '',
        ScimManaged: body.ScimManaged
          ? body.ScimManaged
          : state?.ScimManaged
          ? state.ScimManaged
          : false,
      };
    }
  }
  return state;
};

type ProfileSettingsReducerState = {
  orgAdminInfo: ReturnType<typeof orgAdminInfo>;
  profileInfo: ReturnType<typeof profileInfo>;
};

export const profileSettingsReducer = combineReducers<ProfileSettingsReducerState>({
  orgAdminInfo,
  profileInfo,
});
